import { CoverageTreatmentIdSource } from "@redotech/redo-ab-testing-common/coverage-treatment-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const nullableRatio = z.number().nullable();

const dailyTrendPoint = z.object({
  metricDate: z.string(),
  ordersPerShopper: nullableRatio,
  coverageAttachRate: nullableRatio,
});

const coverageArmMetricView = z.object({
  coverageTreatmentId: z.string(),
  coverageTreatmentIdSource: z.nativeEnum(CoverageTreatmentIdSource),
  latestMetricDate: z.string(),
  assignedShoppers: z.number(),
  addToCartShoppers: z.number(),
  checkoutStartShoppers: z.number(),
  pageViewEvents: z.number(),
  orders: z.number(),
  coverageOrders: z.number(),
  returnsCoverageOrders: z.number(),
  packageProtectionOrders: z.number(),
  revenueInShopCurrency: z.number(),
  shopCurrencyCode: z.string().nullable(),
  widgetShownShoppers: z.number().nullable(),
  addToCartRate: nullableRatio,
  checkoutStartRate: nullableRatio,
  ordersPerShopper: nullableRatio,
  coverageAttachRate: nullableRatio,
  returnsCoverageAttachRate: nullableRatio,
  packageProtectionAttachRate: nullableRatio,
  averageOrderValue: nullableRatio,
  revenuePerShopper: nullableRatio,
  widgetShownRate: nullableRatio,
  windowStart: z.date(),
  dataThrough: z.date(),
  computedAt: z.date(),
  dailyTrend: z.array(dailyTrendPoint),
});

export const getCoverageArmMetrics = {
  name: "getCoverageArmMetrics" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object({ arms: z.array(coverageArmMetricView) }),
};
